import { CoreModel } from './core-model';
import { IdentityInterface } from '@nts/std/interfaces';

export abstract class BaseRootModel<TIdentity extends IdentityInterface>
    extends CoreModel<TIdentity>  {

}
